import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-profile-lightbox',
  templateUrl: './custom-profile-lightbox.component.html',
  styleUrls: ['./custom-profile-lightbox.component.scss']
})
export class CustomProfileLightboxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
